import React from "react";
import styles from "./fba-listings-page-action-buttons.module.css";
import { useFbaListingContext } from "@/contexts/FbaListingContext";
import { Tooltip } from "@/components/Tooltip/Tooltip";
import Button from "@/components/forms/Button/Button";
import IconArrow from "@/components/icons/IconArrow";
import { useLocation } from "wouter";
import Flex from "@/components/Flex/Flex";
import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner";

type FbaListingsPageActionButtonsProps = {};

const FbaListingsPageActionButtons = ({}: FbaListingsPageActionButtonsProps) => {
  const [location, navigate] = useLocation();
  const { fbaListingFlowStep, fbaListings, submitLoading, submitListings } = useFbaListingContext();

  const showContinueButton = fbaListingFlowStep === 0;
  const showViewItemsInInventoryButton = fbaListingFlowStep === 1;
  const disableContinueButton = fbaListings.length === 0 || fbaListings.length > 40;

  const handleContinue = () => {
    //Submit the listings to amazon.
    submitListings();
  };

  const handleViewItemsInInventory = () => {
    const skus = fbaListings.map(l => l.sku);
    navigate(`~/inventory?skus=${skus.join(",")}`);
  };

  return (
    <Flex gap={2}>
      {showContinueButton && (
        <Tooltip
          title={fbaListings.length === 0 ? ("You must create at leased one listing first!") : (fbaListings.length > 40 ? ("You can only create 40 listings at any given time!") : (""))}
        >
          <Button
            size="large"
            type="primary"
            onClick={handleContinue}
            disabled={disableContinueButton || submitLoading}
          >
            <Flex gap={0.5} align="center">
              {submitLoading ? (
                <div className={styles.loaderContainer}>
                  <LoadingSpinner size="1.5rem" />
                </div>
              ) : (
                <>
                  <span>Submit FBA Listings</span>
                  <IconArrow />
                </>
              )}
            </Flex>
          </Button>
        </Tooltip>
      )}

      {showViewItemsInInventoryButton && (
        <Button
          size="large"
          type="primary"
          onClick={handleViewItemsInInventory}
        >
          <Flex gap={0.5} align="center">
            <span>View Listings In Inventory</span>
            <IconArrow />
          </Flex>
        </Button>
      )}
    </Flex>
  );
};

export default FbaListingsPageActionButtons;